import { render, staticRenderFns } from "./LigetLogo.vue?vue&type=template&id=7a7b78e3&scoped=true&"
import script from "./LigetLogo.vue?vue&type=script&lang=js&"
export * from "./LigetLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7b78e3",
  null
  
)

export default component.exports